import React from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import copilotStore from "Stores/copilotStore";
import { LOCAL_ACTIONS, openSupportChat } from "../../agent/agentContract";
import renderMarkdown from "../markdown";

const ErrorCtaBlock = observer(({ block }) => {
  const history = useHistory();

  const handleClick = chip => {
    if (chip.actionId === LOCAL_ACTIONS.NAVIGATE && chip.path) {
      history.push(chip.path);
    }
    if (chip.actionId === LOCAL_ACTIONS.CONTACT_SUPPORT) {
      openSupportChat();
    }
    copilotStore.clickCta(block.id, chip);
  };

  return (
    <div className={`copilotErrorCta severity-${block.severity || "warn"}`}>
      <div className="copilotErrorCta__head">
        <i className="material-icons-outlined">
          {block.severity === "error" ? "report" : "warning"}
        </i>
        <span>{block.title}</span>
      </div>
      {block.markdown && (
        <div className="copilotErrorCta__body">
          {renderMarkdown(block.markdown, path => history.push(path))}
        </div>
      )}
      <div className="copilotErrorCta__chips">
        {(block.chips || []).map(chip => (
          <button
            type="button"
            key={chip.actionId + (chip.label || "")}
            className={`copilotErrorCta__chip ${
              chip.style === "primary" ? "primary" : ""
            }`}
            disabled={copilotStore.streaming}
            onClick={() => handleClick(chip)}
          >
            {chip.icon && (
              <i className="material-icons-outlined">{chip.icon}</i>
            )}
            <span>{chip.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
});

export default ErrorCtaBlock;
